import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-reporting-technical-issue',
  templateUrl: './reporting-technical-issue.component.html',
  styleUrls: ['./reporting-technical-issue.component.scss'],
  standalone: false
})
export class ReportingTechnicalIssueComponent {
  @Input() kind: '3a' | '3b' | 'kid' | 'ci' | 'grow';
}
